export default __webpack_public_path__ + "static/media/lemon_ice_tea.e86fb297.JPG";